import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferTab = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.957 1.516a8.441 8.441 0 00-5.605 14.753 9.97 9.97 0 01-.25-2.226c0-5.491 4.45-9.942 9.94-9.942.766 0 1.51.087 2.227.25a8.42 8.42 0 00-6.312-2.835zm8.77 3.756A9.94 9.94 0 009.958.016C4.467.016.016 4.466.016 9.957a9.94 9.94 0 005.256 8.77 9.94 9.94 0 008.77 5.257c5.491 0 9.942-4.45 9.942-9.942a9.94 9.94 0 00-5.256-8.77zm-4.684.329A8.441 8.441 0 005.6 14.042a8.441 8.441 0 008.442 8.442 8.442 8.442 0 000-16.883z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.962 18.516v.766a.45.45 0 01-.44.449.45.45 0 01-.449-.45v-.775a2.461 2.461 0 01-2.318-2.298.44.44 0 01.44-.5h.326a.439.439 0 01.439.377 1.522 1.522 0 001.675 1.358 1.359 1.359 0 001.532-1.43c0-.888-.541-1.337-1.41-1.756l-1.102-.541a2.706 2.706 0 01-1.757-2.635 2.298 2.298 0 012.175-2.35v-.806a.45.45 0 01.45-.45.45.45 0 01.439.45v.807a2.237 2.237 0 012.175 2.247.44.44 0 01-.44.49h-.357a.46.46 0 01-.439-.378 1.336 1.336 0 00-1.399-1.287 1.236 1.236 0 00-1.399 1.267c0 .857.531 1.235 1.358 1.654l1.022.541a2.768 2.768 0 011.889 2.666 2.471 2.471 0 01-2.41 2.584z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.073 18.51a2.433 2.433 0 01-.111.006v.766a.45.45 0 01-.44.449.45.45 0 01-.449-.45v-.775a2.461 2.461 0 01-2.318-2.298.44.44 0 01.44-.5h.326a.439.439 0 01.439.377 1.522 1.522 0 001.675 1.358 1.359 1.359 0 001.532-1.43c0-.888-.541-1.337-1.41-1.756l-1.102-.541a2.706 2.706 0 01-1.757-2.635 2.298 2.298 0 012.175-2.35v-.806a.45.45 0 01.45-.45.45.45 0 01.439.45v.807a2.23 2.23 0 011.545.68c.407.42.633.982.63 1.567a.44.44 0 01-.44.49h-.357a.46.46 0 01-.439-.378 1.336 1.336 0 00-1.399-1.287 1.236 1.236 0 00-1.399 1.267c0 .857.531 1.235 1.358 1.654l1.022.541a2.768 2.768 0 011.889 2.666 2.471 2.471 0 01-2.299 2.579z",
			fill: "currentColor"
		})
	]
});
export { SvgReferTab as ReactComponent };
